"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lodash_1 = __importDefault(require("lodash"));
const classnames_1 = __importDefault(require("classnames"));
const SelectMenu_1 = __importDefault(require("../styles/SelectMenu"));
exports.default = (0, mobx_react_1.observer)(({ store, handlers }) => (react_1.default.createElement("select", { name: "mobx-react-form-devtools-select", value: store.selected.key, onChange: handlers.handleSelect, className: (0, classnames_1.default)(SelectMenu_1.default.select) }, lodash_1.default.map(store.menu, ($val, $key) => react_1.default.createElement("option", { key: $key, value: $key }, $val)))));
